module.exports = "/_next/static/images/associationLogo6-1511bd0c8c33561620426b45a83c20bc.webp";